<template>
    <div class="slide container">
        <h2>Profit </h2>
        <Countdown :progress="progress" :goal="goal"/>
        <ProgressBar :show-value="true"
                     :current-value="progress"
                     :max-value="goal"
                     :unit="'€'"/>
        <SponsorSwitcher class="mt-5"/>
    </div>
</template>

<script>
    import ProgressBar from '../extras/ProgressBar';
    import SponsorSwitcher from '../extras/SponsorSwitcher';
    import Countdown from '../extras/Countdown';
    import store from '../../services/VuexStore';
    import consts from '../../services/consts';

    export default {
        name: 'CountdownSlide',
        components: {
            ProgressBar,
            SponsorSwitcher,
            Countdown,
        },
        props: {},
        data: () => {
            return {
                progress: 0,
                goal: consts.PV_COSTS
            };
        },
        methods: {
            refresh () {
                this.progress = parseFloat(store.state.money.total);
            },
        },
        mounted() {
            this.refresh();
            setInterval(this.refresh, 2000);
        },
    };
</script>

<style scoped>

</style>
